module.exports = __webpack_public_path__ + "img/mother-of-thousands-7.ddeb1a77.jpeg";